import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl,Table} from "react-bootstrap";
import { API } from "aws-amplify";

import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

import Moment from 'react-moment';
import moment from "moment"
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class AdminUsers extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          myaltioms_fetching:true,
          markdown:"",
          newUser:false,
          responce:"",
          isSuper:false,
          isLoading:true,
          sortmode:"UserCreateDate",
          sortmodereverse:true,
          data:[]
      };
    }

    async componentWillMount() {
      //const data = await this.getInfo();
      //console.log(data)
      //this.setState(data)
      //console.log(this.state)
      let data=await this.getAdmin({admin:true,type:"user",cmd:"listusers"})

      console.log(data)
      if("newUser" in data){
          //not an admin!

      }
      else{
        this.setState({isSuper:true})
        this.setState({data:data})
      }
          this.setState({isLoading:false})

    }

    getAdmin(data){
      let getdata = {
        'queryStringParameters': data
      }
      return API.get("AltiomData", "/welcome",getdata);
    }

    hightlightSort(d){

      if(d==this.state.sortmode){
        return "bolder"
      }
      return ""


    }

    data_sort=(a,b)=>{

      let sA=a[this.state.sortmode]
      let sB=b[this.state.sortmode]
      if(this.state.sortmode=="date"){
        sA=a.date.$date
        sB=b.date.$date
      }

      if(this.state.sortmode=="Username"){
        sA=a.Attributes[2].Value.toLowerCase()
        sB=b.Attributes[2].Value.toLowerCase()
      }


      if(sA<sB){
        if(this.state.sortmodereverse==true)
          return 1
        return -1
      }
      if(sA>sB){
        if(this.state.sortmodereverse==true)
          return -1
        return 1
      }
      return 0
    }

    changeSort=(key)=>{
      console.log(key)
      if(key==this.state.sortmode){
        console.log(this.state.sortmodereverse)
        this.setState({sortmodereverse:!this.state.sortmodereverse})
      }
      this.setState({sortmode:key})
    }



    render() {
      return (
          <div className="Home">
          <Jumbotron>
            <h2><a href="/admin">Admin</a> > Users </h2>


            {/* Need to make this pagnate and search as number of users increases */}
            <hr/>
            {this.state.isSuper==true ? (
            <Table striped bordered condensed hover>
                <thead>
                  <tr>
                  <th className={this.hightlightSort("Username")}>Username <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('Username')}></i></th>
                    <th>Verified</th>
                    <th>Enabled</th>
                    <th className={this.hightlightSort("UserCreateDate")}>Created <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('UserCreateDate')}></i></th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.sort((a,b)=>this.data_sort(a,b,this.state.sortmode)).map((d,index)=><tr key={d.Username}>
                      <td >{d.Attributes[2].Value}</td>
                      <td >{d.UserStatus}</td>
                      <td >{d.Enabled.toString()}</td>
                      <td >{moment(d.UserCreateDate).format('DD/MM/YY HH:mm ')}</td>
                      <td><Button href={"/admin/users/"+d.Username}>View</Button></td>


                    </tr>)}


                </tbody>
            </Table>):(<div>
{this.state.isLoading==true ? (<p>Loading</p>):(<p>No Data for you</p>)}
              </div>
)}









            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/AdminUsers.js